import { render, staticRenderFns } from "./CedTableSicbo.vue?vue&type=template&id=d6846a16"
import script from "./CedTableSicbo.vue?vue&type=script&lang=js"
export * from "./CedTableSicbo.vue?vue&type=script&lang=js"
import style0 from "./CedTableSicbo.vue?vue&type=style&index=0&id=d6846a16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports